import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { memo, useEffect } from "react";
import { CustomFieldModalFormAPIInformation } from "~/components/CustomFields/CustomFieldModal/CustomFieldModalForm/CustomFieldModalFormAPIInformation";
import { initialFormValue } from "~/components/CustomFields/initialCustomFieldFormData";
import { getIsFieldTypeSelectable } from "~/swr-hooks/customFields/utils";
import { CustomFieldModalFormBaseFields } from "./CustomFieldModalFormBaseFields/CustomFieldModalFormBaseFields";
import { CustomFieldModalFormContainer } from "./CustomFieldModalFormContainer";
import { CustomFieldModalFormOptionFields } from "./CustomFieldModalFormOptionFields";
const EDIT_MODAL_DESCRIPTION = "Once saved, these changes will be applied across your workspace.";
const CREATE_MODAL_DESCRIPTION = "Create a single-select, multi-select, plain-text, or date custom field below. The color and value of each option can be customized. Once saved, this field will be available on every asset in your workspace.";
export const CustomFieldModalForm = /*#__PURE__*/ memo((param)=>{
    let { modalType, colors, fieldTypes, setIsSaveDisabled, setIsSaveFocused, setIsEditingCustomFieldOptions } = param;
    const { values, setValues } = useFormikContext();
    const isFieldTypeSelectable = getIsFieldTypeSelectable({
        fieldTypeId: values.fieldTypeId,
        fieldTypes
    });
    useEffect(()=>{
        if (isFieldTypeSelectable && !values.values) {
            // we need to create initial values
            setValues({
                ...values,
                values: initialFormValue.values
            });
        } else if (!isFieldTypeSelectable && !!values.values) {
            // we need to remove the values
            setValues({
                ...values,
                values: undefined
            });
        }
    }, [
        setValues,
        values,
        isFieldTypeSelectable
    ]);
    return /*#__PURE__*/ _jsxs(CustomFieldModalFormContainer, {
        innerScroll: isFieldTypeSelectable,
        children: [
            /*#__PURE__*/ _jsx(CustomFieldModalFormBaseFields, {
                canEditFieldType: modalType === "create",
                fieldTypes: fieldTypes,
                handleDisableSave: setIsSaveDisabled,
                modalDescription: modalType === "edit" ? EDIT_MODAL_DESCRIPTION : CREATE_MODAL_DESCRIPTION
            }),
            isFieldTypeSelectable && /*#__PURE__*/ _jsx(CustomFieldModalFormOptionFields, {
                handleFocusSave: setIsSaveFocused,
                colors: colors,
                handleEditingOptions: setIsEditingCustomFieldOptions,
                handleDisableSave: setIsSaveDisabled
            }),
            /*#__PURE__*/ _jsx(CustomFieldModalFormAPIInformation, {})
        ]
    });
});
CustomFieldModalForm.displayName = "CustomFieldModalForm";
